export default "__VITE_ASSET__DdAndsMw__"